import { createFileRoute } from "@tanstack/react-router";
import { BOMTree } from "@/components/companion/BOMTree";
import { boms } from "@/data/boms";

export const Route = createFileRoute("/bom/$assemblyPartNumber")({
  component: BomDetail,
});

function BomDetail() {
  const { assemblyPartNumber } = Route.useParams();
  const bom = boms.find((b) => b.topAssembly === assemblyPartNumber);
  if (!bom) {
    return <div className="p-6 text-[12px] text-muted-foreground">No BOM found for assembly: <span className="font-mono">{assemblyPartNumber}</span></div>;
  }
  return <BOMTree bomId={bom.id} />;
}
